module.exports = __webpack_public_path__ + "static/media/groceryListIcon3.bbeff822.svg";